
// Set Global fbID
window.fb_id = PM.Get("Application", "facebook_pixel_id");

// On PM Ready
(function(){
	// Check Dnt
	var isDntActive = window && window.navigator && window.navigator.doNotTrack ? window.navigator.doNotTrack === '1' : false;

	// Check in private page
	var isPrivate = ([ 'sifre_degistir' ].indexOf(PM.ActionPage) > -1);

	// Check fb id is alive
	if (!fb_id || isDntActive || isPrivate) return;

	// Parse query string
	var qs = window.location.search.substring(1) ? getQueryVariable(window.location.search.substring(1)) : {};

	// So load global fb
	loadfbq();


	// On Add Cart at product detail
	PM.on("add.cart", function(params) {
		var product;
		PM.OnPage("urun_detay", function() {
			fbq('track', 'AddToCart', { value: google_tag_params.ecomm_totalvalue, currency: 'TRY', contents: [ { id : params.urun_id, quantity: $(".urun_secenekleri > table:eq(0) tr td input#urun_miktar_secenekleri").size() ? parseInt($(".urun_secenekleri > table:eq(0) tr td input#urun_miktar_secenekleri").val(), 10) : 1 } ], content_ids: params.urun_id, content_type: 'product'});
		});

	});

	// On new user register
	PM.on("new.user", function(user) {
		fbq('track', 'Subscribe');
	});

	// On Page Product Detail
	PM.OnPage("urun_detay", function(){
		fbq('track', 'ViewContent', {content_ids: $("input[name='urun_id']").size() ? $("input[name='urun_id']").val() : $("input[id='urun_id']").val(), content_type: 'product'});
	});

	// On Cart View set local storage
	PM.OnPage("sepet_detayi", function(params){

		var products = getProductFromNode();
		
		window.localStorage.setItem("fb_sepet", JSON.stringify(products));
		

	});

	// On Order Step 1
	PM.OnPage("order_step_1", function(params){
		PM.on("process.checkout", function(params){
			fbq('track', 'InitiateCheckout');
		});
	});

	// On Order Step 2
	PM.OnPage("order_step_2", function(params){
		PM.on("process.checkout", function(params){
			fbq('track', 'AddPaymentInfo');
		});
	});

	// On Order End
	PM.OnPage("siparis_sonu", function(){
		if (typeof google_ecommerce_option == 'undefined') return;

		var products = JSON.parse(window.localStorage.getItem("fb_sepet")) || [];
		fbq('track', 'Purchase', {
		  content_ids: products.map((item) => item.id),
		  'value': google_ecommerce_option.revenue.replace('.', '').replace(',', '.'),
		  'currency': 'TRY',
		  content_type: 'product',
		});
		window.localStorage.removeItem("fb_sepet");

	});

	// Send page view
	PM.OnPage("*", function(){
		switch (PM.ActionPage) {
			case 'ana_sayfa': 			return fbq('track', 'PageView');
			case 'arama_sonuclari': 	return fbq('track', 'Search', { search_string: qs.word });
			default:				 	return fbq('track', 'PageView');
		}
	});
})();

function _atob(word) {
	if (!window.atob) return;
	try {
		return atob(word);
	} catch (err) {
		return null;
	}
}


// Call facebook pixel code
function loadfbq() {
	!function(f,b,e,v,n,t,s)
	{
		if (f.fbq) return;
		n = f.fbq = function()
			{
				n.callMethod? n.callMethod.apply(n,arguments):n.queue.push(arguments)
			};
		if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
		n.queue=[];t=b.createElement(e);t.async=!0;
		t.src=v;s=b.getElementsByTagName(e)[0];
		s.parentNode.insertBefore(t,s)
	}(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');

	// Create
	fbq('init', fb_id);
}

// Return product data
function getProductFromNode(el) {
	
		return $(".sepet_urunler tbody tr").map((i, e) => ({
			id : $('a[href*="-pmu"]', e).attr("href").replace(/.*pmu([0-9]+)/i, "$1"),
			price : parseFloat($('td[data-price-wt]',e).data('price-wt').replaceAll('.','').replace(',','.')),
			name : $('a[href*="-pmu"]', e).attr('title').trim(),
			quantity : parseInt($('input#birim', e).val(),10)
		})).toArray()
}

// Parse query string
function getQueryVariable(query) {
	var result = {};
	var vars = query.split('&');
	for (var i = 0; i < vars.length; i++) {
	   var pair = vars[i].split('=');
		try {
			result[decodeURIComponent(pair[0])] = decodeURIComponent(unescape(pair[1]).replace(/\++/gi, '%20')).trim();
		} catch (err) {
			result[pair[0]] = pair[1];
		}
	}
	return result;
}
